import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'minutesToDuration',
  standalone: true,
})
export class MinutesToDurationPipe implements PipeTransform {
  transform(minutes: number): string {
    const h = Math.floor(minutes / 60)
    const m = minutes % 60
    return h > 0 ? `${h}h${m}m` : `${m}m`
  }
}
